import { Link } from "@remix-run/react";
import { cn } from "~/lib/utils";
import { useLocation } from "@remix-run/react";
import { calendarTypes } from "~/components/calendar/calendar-types";

export function CalendarTypeSwitcher({ view = "list", calendarType = "special-events" }) {
  const location = useLocation();

  function isActiveType(type) {
    const url = makeUrl(type);
    return location.pathname === url;
  }

  function makeUrl(type) {
    const prefix = view === "list" ? "events" : "calendar";

    if (type.slug === "") {
      return `/${prefix}`;
    }

    return `/${prefix}/${type.slug}`;
  }

  return (
    <div className="px-3 md:px-0 text-sm">
      {/* <div className="text-sm font-semibold uppercase tracking-wide">Calendar Type</div> */}
      <div className="inline-flex border rounded-md justify-evenly p-2">
        {calendarTypes.map((type) => (
          <Link
            key={type.key}
            to={makeUrl(type)}
            className={cn("px-3 py-1 rounded-sm", {
              "bg-primary/20 font-semibold": isActiveType(type),
            })}
          >
            {type.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
